
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-wins/redeem-prize",
      function () {
        return require("private-next-pages/my-wins/redeem-prize.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-wins/redeem-prize"])
      });
    }
  